/**
 * Se não houver grauRisco, significa que score computado é o valor default do C# (que é 0).
 * O que não representa o score correto, gerando interpretação errada dos dados pelo usuário
 * @habilitadoCalculoDeScores : a entidade guarda a configuração corrente ao qual ela foi criada
 */
export const renderScoreRisco = ({ score, habilitadoCalculoDeScores, grauRisco }) => (habilitadoCalculoDeScores ? (grauRisco ? score : '') : '');
